import { UISearchFieldModel, UIPropertyModel } from "e5core-angular-services";
import { UiStyle } from "../enums/ui-style";

export class SearchResultsModel {
    ui: UiStyle ;

    searchDefinitionId:number;

    pageSize: number;
    page: number ;
    total : number ;

    searchFields : UISearchFieldModel[];
    properties : UIPropertyModel[] ;
    results : any[] ;
}

export function CreateBlankSearchResult(): SearchResultsModel {
    let model = new SearchResultsModel()
    model.ui = UiStyle.Material ;
    return (model) ;
}